import { ReactNode } from 'react';

import {
  BoxProps,
  FormControl,
  FormLabel,
  Textarea as ChakraTextarea,
  TextareaProps as ChakraTextareaProps
} from '@chakra-ui/react';

type TextareaProps = ChakraTextareaProps & {
  label?: string;
  error?: ReactNode;
  touched?: boolean;
  containerProps: BoxProps;
};

const Textarea = ({
  label,
  error,
  id,
  touched,
  containerProps = {},
  ...props
}: TextareaProps) => {
  const isErrorExist = touched !== undefined ? touched && error : error;

  return (
    <FormControl width='full' isInvalid={!!isErrorExist} {...containerProps}>
      {label && (
        <FormLabel fontSize='sm' color='gray.800' htmlFor={id || 'text-area'}>
          {label}
        </FormLabel>
      )}
      <ChakraTextarea
        id={id || 'text-area'}
        border='1px solid'
        bg='transparent'
        borderColor='transparent'
        boxShadow='none !important'
        outline='none'
        _focus={{
          borderColor: 'transparent',
          boxShadow: 'none'
        }}
        _invalid={{
          borderColor: 'red.500',
          boxShadow: 'none',
          bg: 'redOpacity.5'
        }}
        _hover={{
          borderColor: 'transparent'
        }}
        {...props}
      />
    </FormControl>
  );
};

export default Textarea;
